import React from 'react';
import { useTranslate } from '../../../mixins/translate/translate';
import { fetchPost } from '../../../store/fetch';
import { Modal } from '../../common/Modal/Modal';
import { EditPanel, EditPanelButton, EditPanelButtons, EditPanelCell, EditPanelCellLabel, EditPanelSection, EditPanelSelect } from '../../elements';

export function EditProbeMhz(props: { projectId: string; projectName: string; onSaved: () => void }) {
    const [isEditNominalDialogVisible, setIsEditNominalDialogVisible] = React.useState(false);

    const saveNominal = async (probeMhzUpdate: number | undefined) => {
        if (probeMhzUpdate !== undefined) {
            await fetchPost(`/api/utprojects/${props.projectId}/probeMhz/`, undefined, {
                probeMhzUpdate,
            });
            props.onSaved();
        }
        setIsEditNominalDialogVisible(false);
    };

    return (
        <>
            <EditPanelButton text="Edit probe Mhz" small onClick={() => setIsEditNominalDialogVisible(true)} />
            {isEditNominalDialogVisible && (
                <ProbeMhzForm
                    projectId={props.projectId}
                    projectName={props.projectName}
                    onClose={() => setIsEditNominalDialogVisible(false)}
                    onSave={saveNominal}
                />
            )}
        </>
    );
}

function ProbeMhzForm(props: { projectId: string; projectName: string; onClose: () => void; onSave: (probeMhzUpdate: number | undefined) => void }) {
    const translate = useTranslate();
    const [probeMhz, setProbeMhz] = React.useState<number | undefined>(0);

    const handleCloseFormClicked = () => {
        props.onClose();
    };

    return (
        <Modal id="copy-dialog" onClose={() => handleCloseFormClicked()}>
            <Modal.Title>
                <h3>
                    <span className="panel-title">{`Edit probe Mhz ${props.projectName}`}</span>
                </h3>
            </Modal.Title>
            <Modal.Content style={{ height: '100px' }}>
                <div className="admin-form" style={{ width: '100%' }}>
                    <EditPanel>
                        <EditPanelSection>
                            <EditPanelCellLabel rowCount={4} text={'Select new probe Mhz'} />
                        </EditPanelSection>
                        <EditPanelSection>
                            <EditPanelCell rowCount={4}>
                                <EditPanelSelect
                                    name={''}
                                    value={probeMhz ?? ''}
                                    options={[
                                        { text: 'None', value: '0' },
                                        { text: '2', value: '6' },
                                        { text: '4', value: '7' },
                                        { text: '5', value: '2' },
                                        { text: '10', value: '3' },
                                    ]}
                                    handleChange={function (value: string, _name: string): void {
                                        setProbeMhz(Number(value));
                                    }}
                                />
                            </EditPanelCell>
                        </EditPanelSection>
                    </EditPanel>
                </div>
            </Modal.Content>
            <Modal.Actions>
                <EditPanelButtons fixWidth={true}>
                    <EditPanelButton small={true} text={translate('common.close')} onClick={() => handleCloseFormClicked()} />
                    <EditPanelButton small={true} text={translate('common.save')} onClick={() => props.onSave(probeMhz)} primary />
                </EditPanelButtons>
            </Modal.Actions>
        </Modal>
    );
}
